// ----------------------------------------------------------------------

export const authRoutes = [
  {
    path: 'auth',
    children: [],
  },
];
